<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-btn
        small
        text
        icon
        color="success"
        v-on="{ ...dialog }"
      >
        <v-icon>
          mdi-plus
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Time Clock"
      text="Create Time Clock"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-menu
                id="date"
                v-model="outTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
                @input="setSelectorBacktoHour"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="outTimeDisplay"
                    :rules="rules"
                    label="Time Out"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  />
                </template>

                <v-time-picker
                  ref="picker"
                  v-model="selectedOutTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  format="24hr"
                  :min="this.$moment().format('HH:mm')"
                  @click:minute="outTimeMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      employeeUid: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        selectedOutTime: this.$moment().format('HH:mm'),
        outTimeMenu: false,

        rules: [
          value => !!value || 'Required.',
        ],
      }
    },
    computed: {
      outTimeDisplay () {
        return this.selectedOutTime ? this.formatTime(this.selectedOutTime) : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        
        this.resetForm()
      },
    },
    methods: {
      setSelectorBacktoHour () {
        if (this.$refs.picker) {
          this.$refs.picker.selectingHour = true
        }
      },

      formatTime (time) {
        let a = time.split(':') // split it at the colons
        let seconds = (a[0] * 60 * 60) + (a[1] * 60)

        return this.$moment(new Date(1970, 0, 1).setSeconds(seconds)).format('hh:mm A')
      },
     
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.timeClocks().create(this.employeeUid, this.prepareFormData())
              .then((res) => {
                if (res.status === 201) {
                  this.$emit('created')                
                  this.$snack({ message: 'Added Employee Time Clock' })

                  this.dialog = false             
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      
      prepareFormData () {
        return {
          time_out: this.selectedOutTime + ':00',
        }
      },

      resetForm () {
        this.$validator.reset()
      },
    },
  }
</script>
